import Api from "@/api/api";
import store from "@/store/index"

export function getUploadUrl(fileName, fileType) {
    console.log("fileName:>>>>>>>", fileName);
    console.log("fileType:>>>>>>>", fileType)

    let userInfo_account = store.state.userInfo.data.account;

    console.log("origin_userInfo:>>>>>", userInfo_account);
    console.log("$store.userInfo:>>>>>", store.state.userInfo);

    return fetch(Api.getImageUrl + fileName + "&filetype=" + fileType + "&rootName=" + userInfo_account + "&sysName=voiceguide", {
        mode: "cors", // 解决跨域
        method: "get",
        redirect: 'follow'
    })
    .then(response => response.json())
    .then(data => data.presignedUrl)
}

/**
 * 通过url上传
 * @export 上传文件(url方法)通过获取带预签名的链接上传
 * @param {*} url String 预签名链接
 * @param {*} data Object 文件对象
 * @param {*} onProgress Function 进度回调函数 (可选)
 * @return {*} Object { promise: Promise, abort: Function } 返回包含promise和abort方法的对象
 */
export function uploadByUrl(url, data, onProgress) {
    console.log("minio-url:>>>>", url);
    console.log("minio-data:>>>>", data);

    const xhr = new XMLHttpRequest();
    let isAborted = false;
    
    const promise = new Promise((resolve, reject) => {
        // 监听上传进度
        if (onProgress && typeof onProgress === 'function') {
            xhr.upload.addEventListener('progress', (event) => {
                if (event.lengthComputable) {
                    const percentComplete = Math.round((event.loaded / event.total) * 100);
                    onProgress(percentComplete);
                }
            });
        }
        
        // 监听请求完成
        xhr.addEventListener('load', () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve(xhr.response);
            } else {
                reject(new Error(`Upload failed with status ${xhr.status}`));
            }
        });
        
        // 监听请求错误
        xhr.addEventListener('error', () => {
            reject(new Error('Upload failed'));
        });
        
        // 监听请求中止
        xhr.addEventListener('abort', () => {
            if (isAborted) {
                // 如果是主动取消，不抛出错误，而是静默处理
                resolve({ aborted: true });
            } else {
                reject(new Error('Upload aborted'));
            }
        });
        
        xhr.open('PUT', url);
        xhr.setRequestHeader('Accept', 'application/json,text/plain,*/*');
        xhr.send(data);
    });

    // 返回包含promise和abort方法的对象
    return {
        promise,
        abort: () => {
            isAborted = true;
            xhr.abort();
        }
    };
}

/**
 * @export 从存储桶中删除一个对象
 * @param {*} bucketName 存储桶的名字
 * @param {*} objectPathAndName 要删除对象的路径（注意：要写对路径，紧跟存储桶后面的路径）
 * @description 
 * @author 
 * @version V1.0.0
 * @return {*} Promise
 */
export function removeObject(objectPathAndName) {
    return fetch(Api.removeImageUrl + objectPathAndName + "&sysName=voiceguide", {
        mode: "cors", // 解决跨域
        method: "get",
        redirect: 'follow'
    })
    .then(response => response.json())
    .then(data => data)
}